import { Switch, Route } from 'react-router-dom';
import { unathorizedRoutes } from './allRoutes';
import { useUserAuth } from '../state/userAuthContext';

const switchRoutes = (
  <Switch>
    {unathorizedRoutes.map((prop, key) => {
      if (prop.layout === 'unauthorized') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
  </Switch>
);

const Unauthorized = () => {
  const { user } = useUserAuth();
  return <> {user && switchRoutes} </>;
};

export default Unauthorized;
